import { About } from "../About";
import { News } from "../News";

export function MainTab() {
  return <>
    <About />
    <News />
  </>;
}